import { getHostApis } from './getHost'

export async function openInDefaultBrowser(url: string): Promise<void> {
  const { shift, onelaunch } = getHostApis()

  const openLinkOnNewTab = () => window.open(url, '_blank')

  try {
    const shiftAPI = shift?.ntp?.openInDefaultBrowser
    if (shiftAPI) {
      await shiftAPI(url)
      return
    }

    const onelaunchAPI = onelaunch?.openInDefaultBrowser
    if (onelaunchAPI) {
      await onelaunchAPI(url)
      return
    }

    openLinkOnNewTab()
  } catch (e) {
    openLinkOnNewTab()
  }
}
